import { h } from 'preact';

import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

import ArrowBack from '@mui/icons-material/ArrowBack';

import styles from '../../components/global.css';

import LazyPercentileChart from '../../components/percentileChart/lazyPercentileChart.jsx';
import { UrlTable } from './_common.jsx';
import LazyClsUrlRecord from '../../components/clsUrlRecord/lazyClsUrlRecord.jsx';
import LazyVariations from '../../components/variations/lazyVariations.jsx';
import { PharosLink } from '../../components/router/router.jsx';

export default function LazyClsIssueDetail(props) {
  const { propertyId } = props;

  return (
    <>
      <Paper className={`${styles.originArea} ${styles.issueTimings}`}>
        <Typography variant="h5">
          <PharosLink href={propertyId ? `/property/${propertyId}/cls` : ''}>
            <Button color="secondary">
              <ArrowBack className={styles.reportAnchor} />
            </Button>
          </PharosLink>
          <Skeleton
            variant="text"
            width={200}
            height={36}
            sx={{ display: 'inline-block' }}
          />
        </Typography>
      </Paper>

      <Paper className={`${styles.originArea} ${styles.clsPercentile}`}>
        <Typography variant="h6">CLS value</Typography>
        <LazyPercentileChart />
      </Paper>

      <Paper className={`${styles.originArea}`}>
        <Typography variant="h5">Variations</Typography>
        <LazyVariations />
      </Paper>

      <Paper className={`${styles.originArea}`}>
        <div className={styles.urlListHeader}>
          <Typography variant="h5">Affected Urls</Typography>
        </div>
        <UrlTable>
          {Array(30)
            .fill(null)
            .map((_, index) => (
              <LazyClsUrlRecord key={index} />
            ))}
        </UrlTable>
      </Paper>
    </>
  );
}
